import { render } from "./LbrxCustomizeVariantPopup.vue?vue&type=template&id=485bb36e&scoped=true"
import script from "./LbrxCustomizeVariantPopup.vue?vue&type=script&lang=js"
export * from "./LbrxCustomizeVariantPopup.vue?vue&type=script&lang=js"

import "./LbrxCustomizeVariantPopup.vue?vue&type=style&index=0&id=485bb36e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485bb36e"]])

export default __exports__